import { useRouterState } from '@tanstack/react-router';

export function useAppContext() {
	return useRouterState({
		select: (state) => {
			return state.matches.find((match) => match.context)?.context;
		},
	});
}

// Routes where login is MANDATORY — the funnel must be non-skippable (no
// skip/close affordance), because the surface is unusable logged-out. `/_auth`
// is the protected layout (covers every route nested under it via `matches`);
// `/travel-credit-card_/apply` is the standalone CBCC application page. Mirrors
// the 2.x `useLogin({ hideSkip: true })` call sites. Marketing surfaces (e.g.
// the CBCC landing apply CTA) are NOT listed — there login stays skippable.
const MANDATORY_LOGIN_ROUTE_IDS: ReadonlySet<string> = new Set([
	'/_auth',
	'/travel-credit-card_/apply',
]);

/**
 * Whether the currently-active route requires login (so the global funnel must
 * hide its skip/close affordance). Reactive to navigation — drives `hideSkip`
 * on the single `<LoginGate>` since the 3.x `login()` takes no per-call options.
 */
export function useMandatoryLogin(): boolean {
	return useRouterState({
		select: (state) =>
			state.matches.some((match) =>
				MANDATORY_LOGIN_ROUTE_IDS.has(match.routeId),
			),
	});
}
